export default (data) => ({
    init() {
        //
    },
});